import React, {useLayoutEffect} from 'react';
import {Link, Redirect} from 'react-router-dom';
import queryString from 'query-string';

import config, {envIsProd} from '../config';
import {withViewer} from '../graphql/users_get_viewer';
import Loader from '../components/WandbLoader';
import '../css/Home.less';
import {User} from '../types/graphql';
import makeComp from '../util/profiler';
import FeaturedGallery from '../components/FeaturedGallery';

const REDIRECT_TO_SITE = !config.ENVIRONMENT_IS_PRIVATE && envIsProd;

function renderGallery() {
  if (config.ENVIRONMENT_IS_PRIVATE) {
    // Content TBD
    return <div className="main-page" />;
  }
  return (
    <div className="main-page">
      <h2>Featured Gallery</h2>
      <FeaturedGallery match={{params: {}}} />
    </div>
  );
}

interface HomeProps {
  viewerLoading: boolean;
  viewer?: User;
}

// Export Home for testing purposes
export const Home: React.FC<HomeProps> = makeComp(
  ({viewerLoading, viewer}) => {
    const params = queryString.parse(document.location.search);

    useLayoutEffect(() => {
      if (
        !REDIRECT_TO_SITE ||
        params.loader ||
        viewerLoading ||
        viewer != null
      ) {
        return;
      }
      window.location.href = '/site';
    }, [params.loader, viewer, viewerLoading]);

    if (params.loader) {
      let backgroundColor = '#ecbb33';
      if (params.color != null) {
        backgroundColor =
          typeof params.color === 'string' ? params.color : params.color[0];
      }
      return (
        <div
          style={{
            backgroundColor,
            width: '100%',
            height: 500,
            position: 'relative',
          }}>
          <Loader {...params} />
        </div>
      );
    }
    if (viewerLoading) {
      return <Loader />;
    }
    if (viewer != null) {
      return <Redirect to={`/home`} />;
    }

    if (!REDIRECT_TO_SITE) {
      return (
        <div className="front-page">
          <div className="hero">
            <h1>Developer tools for deep learning</h1>
            <h2>Those who don't track training are doomed to repeat it.</h2>
            {!config.ENVIRONMENT_IS_PRIVATE && (
              <Link to="/login?signup=true" data-test="signup">
                Sign Up
              </Link>
            )}
          </div>
          {renderGallery()}
        </div>
      );
    }
    return null;
  },
  {id: 'Home'}
);

export default withViewer(Home);
